import React, { type ReactNode } from "react";
import Image, { type StaticImageData } from "next/image";
import { AspectRatio, Flex, type FlexProps, Text } from "@chakra-ui/react";
import Balancer from "react-wrap-balancer";

export type ImageFeatureCardProps = {
  title: string;
  description: ReactNode;
  image: StaticImageData;
  borderColor?: FlexProps["borderColor"];
};

/**
 * A small card intended to be used in a grid.
 * Used to display copy about a feature above a static image.
 */
export function ImageFeatureCard({ title, description, image, borderColor = "cyan" }: ImageFeatureCardProps) {
  return (
    <Flex direction="column" border="1px" borderColor={borderColor} borderRadius="xl" overflow="hidden" mx="auto">
      <Flex direction="column" gap={3} p={{ base: 6, md: 8, xl: 10 }}>
        <Text as="h3" fontSize={{ base: "lg", sm: "xl", md: "24px" }} fontWeight="semibold" whiteSpace="pre-wrap">
          <Balancer>{title}</Balancer>
        </Text>

        <Text fontSize={{ base: "sm", md: "md" }}>{description}</Text>
      </Flex>

      <AspectRatio ratio={3 / 2} w="100%" pos="relative" mt="auto">
        <Image fill src={image} alt={title} sizes="100%" />
      </AspectRatio>
    </Flex>
  );
}
